/**
 * CM > IPS > 침입탐지 프로파일 > 패턴 학습방어
 *
 * @since 2021-09-09
 * @author wj_tams_dev04
 */
import {SystemApiPrefix as smApiPrefix, CmApiPrefix as cmApiPrefix} from '~/utils/restApi'

class PolicyData {
  constructor (obj, modelType = 'ips') {
    this.keyList = []
    this.orgKeyList = []
    if (_.has(obj, 'ngips_learn_ptrn_policy_ips_prf_id')) this.modelType = 'ips'
    else if (_.has(obj, 'ads_ips_prf_id')) this.modelType = 'ads'
    else this.modelType = modelType
    this.prf_id = this.getValue(obj, ['ngips_learn_ptrn_policy_ips_prf_id', 'ads_ips_prf_id'], 'prf_id')
    this.learn_ptrn_policy_id = this.getValue(obj, ['ngips_learn_ptrn_policy_id', 'ads_lrn_ptrn_plc_id'], 'learn_ptrn_policy_id')
    this.learn_ptrn_policy_use_yn = this.getValue(obj, ['ngips_learn_ptrn_policy_use_yn', 'ads_lrn_ptrn_plc_use_yn'], 'learn_ptrn_policy_use_yn')
    this.learn_ptrn_policy_matching_cnt = this.getValue(obj, ['ngips_learn_ptrn_policy_matching_cnt', 'ads_lrn_ptrn_plc_matching_cnt'], 'learn_ptrn_policy_matching_cnt')
    this.learn_ptrn_policy_active_pps = this.getValue(obj, ['ngips_learn_ptrn_policy_active_pps', 'ads_lrn_ptrn_plc_active_pps'], 'learn_ptrn_policy_active_pps')
    this.learn_ptrn_policy_block_pps = this.getValue(obj, ['ngips_learn_ptrn_policy_block_pps', 'ads_lrn_ptrn_plc_block_pps'], 'learn_ptrn_policy_block_pps')
    this.learn_ptrn_policy_block_tm = this.getValue(obj, ['ngips_learn_ptrn_policy_block_tm', 'ads_lrn_ptrn_plc_block_tm'], 'learn_ptrn_policy_block_tm')
    this.learn_ptrn_policy_msg = this.getValue(obj, ['ngips_learn_ptrn_policy_msg', 'ads_lrn_ptrn_plc_msg'], 'learn_ptrn_policy_msg')
    this.learn_ptrn_policy_action_yn = this.getValue(obj, ['ngips_learn_ptrn_policy_action_yn', 'ads_lrn_ptrn_plc_action_yn'], 'learn_ptrn_policy_action_yn')
    this.learn_ptrn_policy_log_use_yn = this.getValue(obj, ['ngips_learn_ptrn_policy_log_use_yn', 'ads_lrn_ptrn_plc_log_use_yn'], 'learn_ptrn_policy_log_use_yn')
    this.learn_ptrn_policy_dump_use_yn = this.getValue(obj, ['ngips_learn_ptrn_policy_dump_use_yn', 'ads_lrn_ptrn_plc_dump_use_yn'], 'learn_ptrn_policy_dump_use_yn')
    this.learn_ptrn_policy_alert_use_yn = this.getValue(obj, ['ngips_learn_ptrn_policy_alert_use_yn', 'ads_lrn_ptrn_plc_alert_use_yn'], 'learn_ptrn_policy_alert_use_yn')
    this.learn_ptrn_policy_mail_use_yn = this.getValue(obj, ['ngips_learn_ptrn_policy_mail_use_yn', 'ads_lrn_ptrn_plc_mail_use_yn'], 'learn_ptrn_policy_mail_use_yn')
    this.learn_ptrn_policy_alert_sound_use_yn = this.getValue(obj, ['ngips_learn_ptrn_policy_alert_sound_use_yn', 'ads_lrn_ptrn_plc_alert_sound_use_yn'], 'learn_ptrn_policy_alert_sound_use_yn')
    this.ex_addr_list = this.getValue(obj, ['ex_addr_list', 'excpt_addr_list'], 'ex_addr_list')
  }
  getValue (obj, arr, key) {
    this.keyList.push(key)
    this.orgKeyList.push(this.modelType === 'ips' ? arr[0] : arr[1])
    return _.cloneDeep(_.get(_.values(_.pick(obj, [...arr, key])), 0, void 0))
  }
  get () {
    const ret = {}
    _.forEach(this.keyList, key => {
      ret[key] = this[key]
    })
    return ret
  }
  getApiParam () {
    const ret = {}
    _.forEach(this.keyList, (key, idx) => {
      const orgKey = this.orgKeyList[idx]
      ret[orgKey] = this[key]
    })
    return ret
  }
}

// 패턴 설정
class PatternConfigData {
  constructor (obj, modelType = 'ips') {
    if (_.has(obj, 'ngips_learn_ptrn_define_id')) {
      this.modelType = 'ips'
      this.learn_ptrn_define_id = obj.ngips_learn_ptrn_define_id
      this.learn_ptrn_define_name = obj.ngips_learn_ptrn_define_name
      this.use_yn = obj.use_yn
    } else if (_.has(obj, 'ads_lrn_ptrn_def_id')) {
      this.modelType = 'ads'
      this.learn_ptrn_define_id = obj.ads_lrn_ptrn_def_id
      this.learn_ptrn_define_name = obj.ads_lrn_ptrn_def_name
      this.use_yn = obj.use_yn
    } else {
      this.modelType = modelType
      this.learn_ptrn_define_id = obj.learn_ptrn_define_id
      this.learn_ptrn_define_name = obj.learn_ptrn_define_name
      this.use_yn = obj.use_yn
    }
  }
  get () {
    return {
      learn_ptrn_define_id: this.learn_ptrn_define_id,
      learn_ptrn_define_name: this.learn_ptrn_define_name,
      use_yn: this.use_yn
    }
  }
  getApiParam () {
    if (this.modelType === 'ips') {
      return {
        ngips_learn_ptrn_define_id: this.learn_ptrn_define_id,
        ngips_learn_ptrn_define_name: this.learn_ptrn_define_name,
        use_yn: this.use_yn
      }
    } else if (this.modelType === 'ads') {
      return {
        ads_lrn_ptrn_def_id: this.learn_ptrn_define_id,
        ads_lrn_ptrn_def_name: this.learn_ptrn_define_name,
        use_yn: this.use_yn
      }
    }
    return {}
  }
}

// 예외 호스트
class ExceptHostAddForm {
  constructor (obj, modelType = 'ips') {
    this.prf_id = obj.prf_id
    this.modelType = modelType
    this.excpt_host_desc = obj.excpt_host_desc // desc
    this.excpt_list = _.cloneDeep(obj.excpt_list) // 출발지, 목적지
    this.policy_list = _.cloneDeep(obj.policy_list)
  }
  getApiParam () {
    if (this.modelType === 'ips') {
      return {
        ngips_prf_id: this.prf_id,
        ngips_learn_ptrn_policy_msg: this.excpt_host_desc,
        ngips_learn_ptrn_policy_excpt_list: _.map(this.excpt_list, o => {
          return {
            ngips_learn_ptrn_policy_excpt_host_src_addr_obj_id: o.src_addr_obj_id,
            ngips_learn_ptrn_policy_excpt_host_dst_addr_obj_id: o.dst_addr_obj_id
          }
        }),
        ngips_learn_ptrn_policy_list: this.policy_list
      }
    } else if (this.modelType === 'ads') {
      return {
        ads_ips_prf_id: this.prf_id,
        ads_lrn_ptrn_plc_id_list: this.policy_list,
        ads_lrn_ptrn_plc_excpt_list: this.excpt_list
      }
    }
    return {}
  }
}
// (패턴 학습 방어) 예외호스트 Get Form
class ExceptHostGetForm {
  constructor (obj) {
    // ips
    if (_.has(obj, 'ngips_learn_ptrn_policy_msg')) {
      this.policy_exc_desc = obj.ngips_learn_ptrn_policy_msg
      this.items = _.map(obj.items, o => {
        return {
          src_addr_obj_id: o.ngips_learn_ptrn_policy_excpt_src_addr_obj_id,
          src_ip_ver: o.ngips_learn_ptrn_policy_excpt_host_src_ip_ver_type,
          src_name: o.ngips_learn_ptrn_policy_excpt_host_src_obj_uname,
          src_type: o.ngips_learn_ptrn_policy_excpt_host_src_obj_type,
          dst_addr_obj_id: o.ngips_learn_ptrn_policy_excpt_dst_addr_obj_id,
          dst_ip_ver: o.ngips_learn_ptrn_policy_excpt_host_dst_ip_ver_type,
          dst_name: o.ngips_learn_ptrn_policy_excpt_host_dst_obj_uname,
          dst_type: o.ngips_learn_ptrn_policy_excpt_host_dst_obj_type
        }
      })
    }
    // ads
    if (_.has(obj, 'ads_lrn_ptrn_plc_msg')) {
      this.policy_exc_desc = obj.ads_lrn_ptrn_plc_msg
      this.items = _.map(obj.items, o => {
        return {
          src_addr_obj_id: o.src_addr_obj_id,
          src_ip_ver: o.src_ip_ver_type,
          src_name: o.src_obj_uname,
          src_type: o.src_obj_type,
          dst_addr_obj_id: o.dst_addr_obj_id,
          dst_ip_ver: o.dst_ip_ver_type,
          dst_name: o.dst_obj_uname,
          dst_type: o.dst_obj_type
        }
      })
    }
  }
}

export const state = () => ({
  // 패턴 학습 방어 상단
  patternLearningPolicy: [],
  orgPatternLearningPolicy: [],
  // 패턴 설정
  patternSettingInfo: [],
  orgPatternSettingInfo: []
})

export const mutations = {
  initStore (state) {
    state.patternSettingInfo = []
    state.orgPatternSettingInfo = []
    state.patternLearningPolicy = []
    state.orgPatternLearningPolicy = []
  },
  /**
   * 전달된 패턴 학습 정책 속성을 스토어에 저장한다. 호출 시 원본 데이터를 복사하여 org에 따로 저장한다.
   */
  setPatternLearningPolicy (state, policy) {
    state.patternLearningPolicy = _.map(policy, o => new PolicyData(o).get())
    state.orgPatternLearningPolicy = _.cloneDeep(state.patternLearningPolicy)
  },
  /**
   * 전달된 패턴 학습 정책 속성을 스토어에 저장한다.
   */
  setPatternLearningPolicyOnly (state, policy) {
    state.patternLearningPolicy = _.cloneDeep(_.map(policy, o => new PolicyData(o).get()))
  },
  /**
   * 예외호스트를 저장한다.
   */
  setHostItem (state, policy) {
    policy = new PolicyData(policy)
    const copy = _.cloneDeep(state.patternLearningPolicy)
    copy[0].ex_addr_list = policy.ex_addr_list
    state.patternLearningPolicy = copy
  },
  /**
   * 패턴 설정을 스토어에 초기화한다.
   */
  setPatternSetting (state, patterns) {
    state.patternSettingInfo = _.map(patterns, o => new PatternConfigData(o))
    state.orgPatternSettingInfo = _.cloneDeep(state.patternSettingInfo)
  },
  /**
   * 패턴 설정을 스토어에 적용한다.
   */
  setPatternSettingInfo (state, patterns) {
    state.patternSettingInfo = _.map(patterns, o => new PatternConfigData(o))
  }
}

export const actions = {
  /**
   * 패턴 학습 정책 목록을 조회한다.
   */
  async getPatternLearningPolicy ({rootState, commit}, {id, loading = true}) {
    const res = {
      code: 'ok'
    }

    try {
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/defense-learning/patterns/${id}/policies` : `${cmApiPrefix}/adsprf/defense-learning/patterns/${id}/policies`
      const {code, result, reason} = await this.$axios.$get(url, {loading})

      if (code === 'ok') {
        commit('setPatternLearningPolicy', result)
      } else {
        res.code = code
        res.reason = reason
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /**
   * 패턴 학습 정책을 수정한다.
   */
  async setPatternLearningPolicy ({rootState, commit, dispatch}, {profileId, policyId, param, loading = true, successAlert = true}) {
    const res = {
      code: 'ok'
    }

    try {
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/defense-learning/patterns/${profileId}/policies/${policyId}` : `${cmApiPrefix}/adsprf/defense-learning/patterns/${profileId}/policies/${policyId}`
      param = new PolicyData(param, modelType).getApiParam()
      const result = await this.$axios.$put(url, param, {loading, successAlert})

      if (result.code === 'ok') {
        commit('setPatternLearningPolicy', result.result)
      } else {
        res.code = 'nok'
        res.reason = result.result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /**
   * 패턴 학습 정책에 적용된 예외 호스트 정보를 조회한다.
   */
  async getExceptHostDatas ({rootState, commit}, {id, policyId, loading = true, isNotAlert = true}) {
    const res = {
      code: 'ok'
    }

    try {
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/defense-learning/patterns/${id}/policies/${policyId}/exception-ips` : `${cmApiPrefix}/adsprf/defense-learning/patterns/${id}/policies/${policyId}/exception-ips`
      const {code, result} = await this.$axios.$get(url, {loading, isNotAlert})

      if (code === 'ok') {
        res.result = new ExceptHostGetForm(result)
      } else {
        res.code = code
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /**
   * 패턴 학습 정책에 적용된 예외 호스트 정보를 수정한다.
   */
  async setExceptHostDatas ({rootState, commit, dispatch}, {params, loading = true, successAlert = true}) {
    const res = {
      code: 'ok'
    }

    try {
      const profileId = params.prf_id
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/defense-learning/patterns/${profileId}/policies/exception-ips` : `${cmApiPrefix}/adsprf/defense-learning/patterns/${profileId}/policies/exception-ips`
      params = new ExceptHostAddForm(params, modelType).getApiParam()
      const {code, result} = await this.$axios.$put(url, params, {loading, successAlert})

      if (code === 'ok') {
        res.result = result
        commit('setHostItem', result[0])
      } else {
        res.code = 'nok'
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /**
   * 패턴 목록을 조회한다.
   */
  async getPatternSetting ({rootState, state, commit}, {id, loading = true}) {
    const res = {
      code: 'ok'
    }

    try {
      const policyId = state.patternLearningPolicy[0].learn_ptrn_policy_id
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/defense-learning/patterns/${id}/policies/${policyId}/groups` : `${cmApiPrefix}/adsprf/defense-learning/patterns/${id}/policies/${policyId}/groups`
      const {code, result, reason} = await this.$axios.$get(url, {loading})

      if (code === 'ok') {
        commit('setPatternSetting', result)
      } else {
        res.code = code
        res.reason = reason
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /**
   * 전달된 패턴으로 수정을 요청한다.
   */
  async setPatternSetting ({rootState, state, commit, dispatch}, {profileId, policyId, params, loading = true, successAlert = true}) {
    const res = {
      code: 'ok'
    }

    try {
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/defense-learning/patterns/${profileId}/policies/${policyId}/groups` : `${cmApiPrefix}/adsprf/defense-learning/patterns/${profileId}/policies/${policyId}/groups`
      const reqParam = (modelType === 'ips') ? {ngips_learn_ptrn_define_list: params} : {ads_lrn_ptrn_def_list: params}
      const {code, result} = await this.$axios.$put(url, reqParam, {loading, successAlert})

      if (code === 'ok') {
        commit('setPatternSetting', result)
      } else {
        res.code = 'nok'
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  }
}
